import { Concept } from './../../../_models/concept';
import { ContentService } from './../../../_services/content.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-concept-show',
  templateUrl: './admin-concept-show.component.html',
  styleUrls: ['./admin-concept-show.component.css']
})
export class AdminConceptShowComponent implements OnInit {
  conceptItem = new Concept()
  constructor(
    private activatedRoute:ActivatedRoute,
    private contentService:ContentService
  ) { }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(
      params=>{
        this.contentService.getConcept(params['server_concept_id']).subscribe(
          x=>{

            this.conceptItem=x
          }
        )
      }
    )
  }

}
